import axios from 'axios'
import { BASE_URL, dataGetter } from 'utils/api'

export const all = (farmOwnerId, business_id, params, to_month) => {
  console.log('typeof business_id:', typeof business_id, business_id)
  console.log('FOID', farmOwnerId)
  const RESOURCE_LOCATION = `${BASE_URL}/api/farm_owners/${farmOwnerId}/accounting/businesses/`
  return axios
    .post(`${RESOURCE_LOCATION}${business_id}/monthly_summary/`,
      { ...params, to_month },
    )
    .then(({ data }) => data)
}